import { apiRawGet, apiRawPost } from './apiClient';

export const AccountService = {
  cancelMembership: async (): Promise<{ message: string; currentPeriodEnd?: string | null }> => {
    const res = await apiRawPost('/api/stripe/subscription/cancel', {});
    if (!res.ok) {
      const payload = await res.json().catch(() => ({} as { message?: string }));
      throw new Error(payload.message ?? `HTTP ${res.status}`);
    }

    return res.json();
  },

  downloadMyData: async (): Promise<Blob> => {
    const res = await apiRawGet('/Auth/me/export');
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return res.blob();
  },
};
